type Typography = { [k: string]: any };

const typography: Typography = {
  useNextVariants: true,
  fontFamily: "Readex Pro",

  h1: {
    fontFamily: "Readex Pro",
    fontSize: "96px",
    lineHeight: "112.03px",
    letterSpacing: "-1.5px",
  },
  h2: {
    fontFamily: "Readex Pro",
    fontSize: "60px",
    lineHeight: "72px",
    letterSpacing: "-0.5px",
  },
  h3: {
    fontFamily: "Readex Pro Medium",
    fontSize: "48px",
    lineHeight: "56.02px",
  },
  h4: {
    fontFamily: "Readex Pro Medium",
    fontSize: "34px",
    lineHeight: "41.99px",
    letterSpacing: "0.25px",
  },
  h5: {
    fontFamily: "Readex Pro Medium",
    fontSize: "24px",
    lineHeight: "32.02px",
  },
  h6: {
    fontFamily: "Readex Pro Black",
    fontSize: "20px",
    letterSpacing: "0.15px",
    lineHeight: "32px",
  },
  subtitle1: {
    fontFamily: "Readex Pro Medium",
    fontSize: "16px",
    letterSpacing: "0.15px",
    lineHeight: "24px",
  },
  subtitle2: {
    fontFamily: "Readex Pro Medium",
    fontSize: "14px",
    letterSpacing: "0.1px",
    lineHeight: "22px",
  },
  body1: {
    fontFamily: "Readex Pro",
    fontSize: "16px",
    letterSpacing: "0.15px",
    lineHeight: "24px",
  },
  body2: {
    fontFamily: "Readex Pro",
    fontSize: "14px",
    letterSpacing: "0.15px",
    lineHeight: "20px",
  },
  buttonLarge: {
    fontFamily: "Readex Pro Black",
    fontSize: "15px",
    letterSpacing: "0.46px",
    lineHeight: "26px",
    textTransform: "uppercase",
  },
  buttonMedium: {
    fontFamily: "Readex Pro Black",
    fontSize: "14px",
    letterSpacing: "0.46px",
    lineHeight: "24px",
    textTransform: "uppercase",
  },
  buttonSmall: {
    fontFamily: "Readex Pro Black",
    fontSize: "13px",
    letterSpacing: "0.46px",
    lineHeight: "22px",
    textTransform: "uppercase",
  },
  caption: {
    fontSize: "12px",
    letterSpacing: "0.4px",
    lineHeight: "20px",
    fontFamily: "Readex Pro Medium",
  },
  overline: {
    fontFamily: "Readex Pro Medium",
    fontSize: "12px",
    letterSpacing: "1px",
    lineHeight: "32px",
    textTransform: "uppercase",
  },
  inputLabel: {
    fontFamily: "Readex Pro Medium",
    fontSize: "12px",
    letterSpacing: "0.15px",
    lineHeight: "12px",
  },
  helperText: {
    fontFamily: "Readex Pro",
    fontSize: "11px",
    letterSpacing: "0.4px",
    lineHeight: "16px",
  },
  inputText: {
    fontFamily: "Readex Pro Medium",
    fontSize: "16px",
    letterSpacing: "0.15px",
    lineHeight: "22px",
  },
  tooltip: {
    fontFamily: "Readex Pro Black",
    fontSize: "10px",
    lineHeight: "14px",
  },

  navbarIcon: {
    height: "32px",
    width: "32px",
    fontSize: "32px",
  },
};

export default typography;
